/* ============
 * Create Page
 * ============
 *
 * This page creates client.
 */

import { mapGetters } from 'vuex';
import supplierService from './../../../../services/supplier';
import countryService from './../../../../services/country';
import postalService from './../../../../services/postal';
import supplierTransformer from './../../../../transformers/supplier';
import Forms from './../../../../utils/forms/forms';

export default {
  data() {
    return {
      formBasicInformation: new Forms({
        code: {
          value: '',
          type: 'text',
        },
        name: {
          value: '',
          type: 'text',
        },
      }),
      formContactInformation: new Forms({
        email: {
          value: '',
          type: 'text',
        },
        phonenumber: {
          value: '',
          type: 'text',
        },
        mobilenumber: {
          value: '',
          type: 'text',
        },
      }),
      formAddressInformation: new Forms({
        streetName1: {
          value: '',
          type: 'text',
        },
        streetName2: {
          value: '',
          type: 'text',
        },
        postalCode: {
          value: '',
          type: 'text',
        },
        city: {
          value: '',
          type: 'text',
        },
        countryId: {
          value: 1,
          type: 'select',
        },
      }),

      loading: true,
      tabIndex: '1',
    };
  },

  computed: {
    ...mapGetters({
      countries: 'allCountries',
      municipalities: 'allMunicipalities',
      postals: 'allPostals',
      supplier:'currentSupplier'
    }),
  },

  watch: {
    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} countries    The countries list.
     */
    countries(countries) {
      this.formAddressInformation.setOptions('countryId', countries.items);
    },

    $route() {
      this.urlCurrentTab();
    },

    tabIndex(value) {
      this.assignTab(value);
    },
  },

  mounted() {
    this.urlCurrentTab();
    this.assignTab(this.tabIndex);
  },

  created() {
    this.show();
  },

  methods: {

    assignTab(value) {
      let tab = '';
      if (value == '3') {
        tab = '#address';
      } else if (value == '2') {
        tab = '#contact';
      } else {
        tab = '#basic';
      }
      history.pushState({}, null, '/#'+this.$route.path + tab);
    },

    urlCurrentTab() {
      if (this.$router.currentRoute.hash == '#address') {
        this.tabIndex = '3';
      } else if (this.$router.currentRoute.hash == '#contact') {
        this.tabIndex = '2';
      } else {
        this.tabIndex = '1';
      }
    },

    /**
     * Method to store the client
     */
    update() {
      this.loading = false;
      this.formBasicInformation.loading = true;
      const supp = supplierTransformer.send(
        Object.assign({}, this.formBasicInformation.data(), this.formContactInformation.data(), this.formAddressInformation.data())
      );
      console.log(supp);
      supplierService.update(this.$route.params.id, supp)
      .then(() => {
        this.$message({
          message: this.$t('static.supplier.update.success'),
          type: 'success',
        });
        this.$router.push({
          name: 'supplier.index',
        });
      }).catch((errors) => {
        this.formBasicInformation.loading = false;
        this.formAddressInformation.recordErrors(errors);
        this.formContactInformation.recordErrors(errors);
        this.formBasicInformation.recordErrors(errors);

        if (this.formBasicInformation.errors.any()) {
          this.tabIndex = '1';
        } else if (this.formAddressInformation.errors.any()) {
          this.tabIndex = '3';
        } else if (this.formContactInformation.errors.any()) {
          this.tabIndex = '2';
        }
      });
    },

    /**
     * Method to display the city
     */
    showCityByPostalCode(postalCode) {
      if (this.postals.items.length > 0) {
        const postal = this.postals.items.filter(p => (
          postalCode === p.postalCode.toString()
        ))[0];

        this.formOtherInformation.cityName = postal.cityName;
      }
    },

    /**
     * Fetches the supplier object for editing.
     */
    show() {
      this.loading = true;
      Promise.all([
        supplierService.show(this.$route.params.id),
        countryService.all(),
      ]).then((data) => {
        this.loading = false;
        const supp = data[0]
        this.formBasicInformation.disableField('code');
        this.formBasicInformation.assignData(supp);
        this.formAddressInformation.assignData(supp.address);
        this.formContactInformation.assignData(supp.contact);
      });
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/supplier/edit/edit.js